<template>
  <Flicking
    :options="flickingOptions"
    :plugins="activePlugins"
    @changed="handleChange"
    ref="flicking"
    v-if="true"
  >
    <slot name="content"></slot>
    <template #viewport>
      <div class="flicking-pagination" v-if="pagination"></div>
    </template>
  </Flicking>
</template>

<script setup>
  import Flicking from '@egjs/vue3-flicking'
  import { Pagination, AutoPlay, Perspective } from '@egjs/flicking-plugins'
  import '@egjs/flicking-plugins/dist/pagination.css'
  import { ref, onMounted,computed } from 'vue'

  const props = defineProps({
    heightViewport: { type: String, default: '600px' },
    heightCamera: { type: String, default: '600px' },
    heightDekstopCamera: { type: String, default: 'auto' },
    paginationBottom: { type: String, default: '15px' },
    autoplay: { type: Boolean, default: false },
    autoplayTime: { default: 5000 },
    circular: { type: Boolean, default: false },
    bound: { type: Boolean, default: true },
    pagination: { type: Boolean, default: true },
    perspective: { type: Boolean, default: false },
    align: { type: String, default: 'prev' },
    map: { type: Boolean, default: false },
    duration: { type: String, default: '500' },
  })

  const flickingOptions = computed(() => {
    return {
    circular: props.circular,
    autoResize: true,
    bound: props.bound,
    align: props.align,
    moveType: 'strict',
    defaultIndex: 0,
    panelsPerView: -1,
    preventDefaultOnDrag: true,
    inputType: ['touch', 'mouse', 'pointer'],
    noPanelStyleOverride: true,
    duration: props.duration
  }})

  const paginationPlugin = new Pagination({ type: 'bullet' })
  const autoplayPlugin = new AutoPlay({
    duration: props.autoplayTime,
    direction: 'NEXT',
    stopOnHover: false
  })
  const perspective = new Perspective({ rotate: 0.5 })

  const activePlugins = []
  if (props.pagination) {
    activePlugins.push(paginationPlugin)
  }
  if (props.autoplay) {
    activePlugins.push(autoplayPlugin)
  }
  if (props.perspective) {
    activePlugins.push(perspective)
  }

  const selectedIndex = ref(0)
  const emit = defineEmits(['changeMapImage'])
  const flicking = ref(null)

  const handleChange = () => {
    const flickingInstance = flicking.value
    if (flickingInstance) {
      const currentPanel = flickingInstance.panels[flickingInstance.index]
      if (currentPanel) {
        selectedIndex.value = flickingInstance.index
        if (props.map) {
          emit('changeMapImage', flickingInstance.index)
        }
      }
    }
  }

  const moveToPanel = (index) => {
    if (flicking.value) {
      flicking.value.moveTo(index, 0)
    }
  }
  defineExpose({ moveToPanel })

  onMounted(() => {
    const flickingInstance = flicking.value
    if (flickingInstance) {
      const currentPanel = flickingInstance.panels[flickingInstance.index]
      if (currentPanel) {
        selectedIndex.value = flickingInstance.index
        if (props.map) {
          emit('changeMapImage', flickingInstance.index)
        }
      }
    }
  })
</script>

<style lang="scss">
  @import '@/scss/mixings';

  .flicking-viewport {
    margin-left: auto;
    margin-right: auto;
    transition: height 0.5s;
    width: 100%;
    height: v-bind(heightViewport);
    overflow: hidden;
    position: relative;
    @media screen and (min-width: $sm-breakpoint) {
      height: v-bind(heightDekstopCamera);
    }

    .flicking-camera {
      @include d-flex(row, initial, initial);
      height: v-bind(heightCamera);
      width: 100%;
      position: relative;
      will-change: transform;
      z-index: 1;
      .flicking-panel {
        flex-shrink: 0;
        padding: 0px;
        width: 100%;
        .flicking--image {
          width: 100%;
          height: 600px;
          object-fit: cover;
        }
      }
    }
  }
  .flicking-pagination {
    @include d-flex(row, center, center);
    gap: 5px;
    position: absolute;
    bottom: v-bind(paginationBottom);
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    &-bullet {
      background: var(--neutral-40);
      border-radius: 50%;
      cursor: pointer;
      display: inline-block;
      font-size: 1rem;
      height: 8px;
      width: 8px;
      margin: 0 2px;
      &-active {
        background-color: var(--primary-10-color);
      }
    }
  }
</style>
